import {
    createRouter,
    createWebHistory
} from "vue-router";
import { jwtDecode as jwt_decode } from 'jwt-decode';
import storage from '../utils/storage';
import { ElMessage } from "element-plus";

const index = () => import("../views/Index.vue")
const login = () => import("../views/Login.vue")
const signup = () => import("../views/Signup.vue")
const oauthAuthorize = () => import("../views/OAuthAuthorize.vue")
const teacherHome = () => import("../views/TeacherHome.vue")
const adminHome = () => import("../views/AdminHome.vue")
const studentHome = () => import("../views/StudentHome.vue")
const therapistHome = () => import("../views/TherapistHome.vue")
const about = () => import("../views/About.vue")

const routes = [
    {
        path: "/",
        redirect: "/login"
    },
    {
        path: "/index",
        name: "index",
        component: index
    },
    {
        path: "/login",
        name: "login",
        component: login
    },
    {
        path: "/about",
        name: "about",
        component: about
    },
    {
        path: "/signup/:userType",
        name: "signup",
        component: signup
    },
    {
        path: "/oauth/authorize",
        name: "oauthAuthorize",
        component: oauthAuthorize
    },
    {
        path: "/teacherHome/:userId",
        name: "teacherHome",
        component: teacherHome,
        meta: { requireAuth: true }
    },
    {
        path: "/adminHome/:userId",
        name: "adminHome",
        component: adminHome,
        meta: { requireAuth: true }
    },
    {
        path: "/studentHome/:userId",
        name: "studentHome",
        component: studentHome,
        meta: { requireAuth: true }
    },
    {
        path: "/therapistHome/:userId",
        name: "therapistHome",
        component: therapistHome,
        meta: { requireAuth: true }
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes: routes
})

// check token for the page required, or back to login page
router.beforeEach((to, from, next) => {
    if (to.matched.some(r => r.meta.requireAuth) !== false) {
        let token = storage.get('TOKEN')
        let userId = storage.get('USER_ID')
        if (token) {
            try{
                // Decode the token to check its validity
                const decoded = jwt_decode(token);
            
                // check if userId exists in the decoded token is the same as the one in the route params                
                if (to.params.userId && String(userId) !== to.params.userId) {
                    ElMessage({
                        message: "Wrong access, please login again",
                        type: "error",
                    });
                    storage.remove('TOKEN');
                    next({ path: "/login" });
                    return;
                }else{
                    next();
                }
        }catch (e) {               
                ElMessage({
                message: "Error, please login again",
                type: "error",
            });
            storage.remove('TOKEN')
            next({ path: "/login" });
            }
        } else {
            ElMessage({
                message: "No valid token, please login",
                type: "error",
            });
            storage.remove('TOKEN')
            next({ path: "/login" });
        }
    } else {
        next();
    }
});

export default router

